export default __webpack_public_path__ + "static/media/vindication.6739ce9f.png";